var map = {
	"./001.svg": 6543,
	"./341.svg": 9296,
	"./353.svg": 3621,
	"./422.svg": 9942,
	"assets/images/bancos/001.svg": 6543,
	"assets/images/bancos/341.svg": 9296,
	"assets/images/bancos/353.svg": 3621,
	"assets/images/bancos/422.svg": 9942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3190;